module.exports = __webpack_public_path__ + "media/images/default/shared/footer/map-784b101278c76ef5425286c8df41d854.svg";